/*
* PdfBulletListContent.js
* Created on 22-11-2017
* @author Olivier for &ranj
*/

import { isNull, isUndefined } from "../../../util/TypeUtil";
import PdfHorizontalContentContainer from "./PdfHorizontalContentContainer";
import PdfVerticalContentContainer from "./PdfVerticalContentContainer";

export default class PdfBulletListContent extends PdfVerticalContentContainer {
    constructor(style, texts, textStyle) {
        super(style);

        this._font = { family: 'helvetica', size: 12, color: [0, 0, 0], style: "normal" };

        this._bulletSize = 1.25;
        this._bulletOffsetX = 8;
        this._bulletOffsetY = 3;

        if (isNull(style)) {
            style = {};
        }
        if (isNull(style.width)) {
            style.width = 365;
        }

        if (!isUndefined(texts)) {
            for (var i = 0; i < texts.length; i++) {
                this.addBulletPointForText(texts[i], textStyle);
            }
        }
    }

    setPropertiesFromObject(obj) {
        super.setPropertiesFromObject(obj);

        for (let property in obj) {
            if (obj.hasOwnProperty(property)) {
                switch (property) {
                    case ("bulletSize"): this.setBulletSize(obj[property]); break;
                    case ("bulletOffsetX"): this._bullsetOffsetX = obj[property]; break;
                    case ("bulletOffsetY"): this._bullsetOffsetY = obj[property]; break;
                }
            }
        }
    }

    setBulletSize(size) {
        this._bulletSize = size;
    }

    addBulletPointForText(text, style) {
        let bulletPointRow = new PdfHorizontalContentContainer(2, { width: this._width });
        bulletPointRow.setColumnWidthDistribution([18, this._width - 18]);

        if (isUndefined(style)) {
            style = this._data;
        }
        bulletPointRow.getColumn(2).addText(text, style);

        this.addContent(bulletPointRow);
    }

    printToDocument(doc, x, y) {
        super.printToDocument(doc, x, y);

        let top = y + this._padding[0];
        let left = x + this._padding[3] + this._bulletOffsetX;

        //draw bullet points
        for (let i = 0; i < this._content.length; i++) {
            let curY = top;
            for (let j = 0; j < i; j++) {
                curY += this._content[j].getFullHeight();
            }

            doc.circle(left, curY + this._bulletOffsetY, this._bulletSize, "F");
        }
    };
}